import React from "react"

const DealCodesContext = React.createContext({})

const { Provider, Consumer } = DealCodesContext

export { Provider, Consumer, DealCodesContext }
